import React, {useState , useEffect } from 'react';
import { useNavigate,useParams } from 'react-router-dom';

import { Modal, Button } from "react-bootstrap";
import { FaRegCopy, FaTimesCircle, FaArrowUp,  FaExchangeAlt, FaQuestionCircle,  FaEnvelope, FaPhoneAlt, FaCalendarAlt, FaBed , FaDownload, FaClock , FaPrint , FaCommentDots , FaCalendarCheck, FaCalendarTimes, FaUsers, FaMapMarkerAlt} from "react-icons/fa";


import "./BookingConfirmation.css";
import CancelBooking from "./CancelBooking";
import { toast } from "react-toastify";


import "./BookingSteps.css";


const ConfirmationBooking = () => {
  const [agree, setAgree] = useState(true);
 
  const navigate = useNavigate();
const { bookingId } = useParams();

  const [property , setProperty] = useState({})
  const [BooingDate , setBooingDate] = useState({})

  const [showPopup, setShowPopup] = useState(false);

  const [show, setShow] = useState(false);




    const [agree1, setAgree1] = useState(false);
  const [loading, setLoading] = useState(false);












const [showCancelModal, setShowCancelModal] = useState(false);
const [cancelling, setCancelling] = useState(false);

// open modal
const openCancelModal = () => setShowCancelModal(true);
const closeCancelModal = () => setShowCancelModal(false);








 
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

    const steps = [
    { id: 1, label: "Your Selection" },
    { id: 2, label: "Your Details" },
    { id: 3, label: "Finish Booking" },
  ];


  useEffect(() => {
    window.scrollTo(0, 0);
    let property1 = JSON.parse(localStorage.getItem("Selected_Room"))
    let BooingData = JSON.parse(localStorage.getItem("BookingDate"))
    setProperty(property1)
    setBooingDate(BooingData)
    console.log(property1)
  }, []);


  const handleCopy = () => navigator.clipboard.writeText(bookingId);
















const handleCancelBooking = async () => {
  setCancelling(true);
  try {
    const response = await fetch(`https://striking-dedication-production.up.railway.app/api/v1/user/bookings/cancel/${JSON.parse(localStorage.getItem("BookingDetail")).id}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        // "Authorization": `Bearer ${localStorage.getItem("authToken")}`, // اگر token چاہیے
      },
      // body: JSON.stringify({ reason: "user cancelled" }) // اگر API reason چاہتی ہے
    });

    if (!response.ok) {
      throw new Error("Failed to cancel booking");
    }

    const data = await response.json();
    console.log("Cancelled Booking Response:", data);

    setCancelling(false);
    closeCancelModal();
    toast.success("Booking cancelled successfully!");

    
    // Optional: redirect یا state update
    navigate("/");


  } catch (error) {
    setCancelling(false);
    console.error(error);
    toast.success("Error cancelling booking");
  }
};














  const handleSubmit = (e) => {
    e.preventDefault();
    if (!agree) {
      toast.success("Please agree to continue.");
      return;
    }


        setLoading(true);
    // Simulate API / booking confirm delay

         setTimeout(() => {
      setLoading(false);
      toast.success("Booking completed successfully!");
      // yaha redirect bhi kar sakte ho e.g. window.location.href = "/success"
    }, 3000);

    // redirect or API call yaha kar sakte ho
  };

  return (

     <div>
      <br />
<div className="steps-container">
      {steps.map((step, index) => (
        <div key={step.id} className="step-item">
          <div
            className={`step-circle ${
              3 >= step.id ? "active" : ""
            }`}
          >
            {step.id}
          </div>
          <span
            className={`step-label ${
              3 >= step.id ? "active-label" : ""
            }`}
          >
            {step.label}
          </span>
          {index < steps.length - 1 && (
            <div
              className={`step-line ${
                3 > step.id ? "active-line" : ""
              }`}
            ></div>
          )}
        </div>
      ))}
    </div>


      <div className="container">
        <div className="row">
          <div className="col-lg-8">





   <div className="booking-confirmation">

      {/* Confirmation Header */}
      <div className="confirmation-header">
        <h3 className="text-success">Confirmed</h3>
        <h2>Your booking in Karachi is confirmed.</h2>
        <ul>
          <li>Your confirmation is on its way to <b>{JSON.parse(localStorage.getItem("AllBookingData")).formData.email}</b> 
          {/* <a href="#">Edit</a> */}
          </li>
          <li> Your payment will be handled by {property.property?.propertyName}. The Price section below has more details.</li>
        </ul>
        {/* <div className="confirmation-actions">
          <button className="btn btn-primary">         <FaPrint style={{marginRight :"10px"}} size={14} />
 Print full version</button>
          <button className="btn btn-outline-primary">        <FaDownload style={{marginRight :"10px"}} size={14} />
 Save confirmation to phone</button>
        </div>*/}
      </div> 

      {/* Safety Notice */}
      <div className="safety-box">
        <h5><FaClock style={{marginRight :"10px", color:"red"}} size={18} />Stay safe online</h5>
        <p>
          Protect your security by never sharing your personal or credit card information over the phone, by email, or chat. <br /> <a href="/trust-and-safety/travellers.en-us">Learn more</a>
        </p>
      </div>





       <div className="booking-messages">

      {/* Arrival Time */}
      <div className="message-item">
        <FaClock className="msg-icon" />
        <div>
          <h4>Arrival time – <span className="new-msg">New message</span></h4>
          <p>You requested to check in at {property.property?.checkIn.from} – {property.property?.checkIn.until}.</p>
          <p>The property has started a conversation about your request.</p>
          <a href="#">Message property</a>
        </div>
      </div>

      {/* Special Request */}
      <div className="message-item">
        <FaCommentDots className="msg-icon" />
        <div>
          <h4>Special request</h4>
          <p>
            The property may get in touch via inbox message <br />
            Approximate time of arrival: between {property.property?.checkIn.from} and  {property.property?.checkIn.until}
          </p>
          <p>
            This guest is interested in your airport shuttle service and would
            like to get more information from you.
          </p>
        </div>
      </div>

      {/* Inbox Message */}
      <div className="message-item">
        <FaEnvelope className="msg-icon" />
        <div>
          <h4>Inbox message</h4>
          <p>
            Property: “Respected Guest, Kindly confirm your expected time of
            Check-In? Thank you & Regards, {property.property?.propertyName}
          </p>
          <a href="#">View message</a>
        </div>
      </div>
    </div>






<div className="booking-details-box">
      {/* Hotel Title */}
      <h2 className="hotel-title">
        {property.property?.propertyName} <span className="genius-badge">Genius</span>
      </h2>

      <div className="details-grid">
        {/* Check-in / Check-out */}

        <div className="checkin-box">
                              <FaCalendarCheck className="detail-icon" />

          <p className="label">Check-in</p>
          <p className="date">{BooingDate ? new Date(BooingDate.checkIn).toLocaleDateString("en-US", { weekday: "short" }) : ""}, {property.bookingDate?.startDate}</p>
          <p className="label">Timing</p>

          <p className="time"> {property.property?.checkIn.from} – {property.property?.checkIn.until}</p>
          {/* <a href="#">Change dates</a> */}
        </div>

        <div className="checkout-box">
                      <FaCalendarTimes className="detail-icon" />

          <p className="label">Check-out</p>
          <p className="date">{BooingDate? new Date(BooingDate.checkOut).toLocaleDateString("en-US", { weekday: "short" }) : ""}, {property.bookingDate?.endDate}</p>
          <p className="label">Timing</p>
          <p className="time">{property.property?.checkOut.from} – {property.property?.checkOut.until}</p>
        </div>

        {/* Hotel Image */}
        <div className="hotel-img">
          <img
            src={property.property?.images[0]}
            alt="Room"
          />
        </div>
      </div>


      {/* Booking details */}
      <p className="booking-info">
           <FaUsers className="detail-icon" />
     {/* 2 adults · 2 weeks · 1 room */}
  
    {Math.ceil(
      (new Date(BooingDate?.checkOut) - new Date(BooingDate?.checkIn)) / (1000 * 60 * 60 * 24)
    )}{" "}
    night{Math.ceil((new Date(BooingDate?.checkOut) - new Date(BooingDate?.checkIn)) / (1000 * 60 * 60 * 24)) > 1 ? "s" : ""},{" "}
    {property?.noOfRooms} room{property?.noOfRooms > 1 ? "s" : ""} for {BooingDate?.adults} adult{BooingDate?.adults > 1 ? "s" : ""}
    {BooingDate?.children > 0 ? ` and ${BooingDate?.children} child${BooingDate?.children > 1 ? "ren" : ""}` : ""}
  


        {/* <a href="#"> Add space for more guests</a> */}
      </p>

      {/* <p>
  <strong>
    {Math.ceil(
      (new Date(BooingDate?.checkOut) - new Date(BooingDate?.checkIn)) / (1000 * 60 * 60 * 24)
    )}{" "}
    night{Math.ceil((new Date(BooingDate?.checkOut) - new Date(BooingDate?.checkIn)) / (1000 * 60 * 60 * 24)) > 1 ? "s" : ""},{" "}
    {property?.noOfRooms} room{property?.noOfRooms > 1 ? "s" : ""} for {BooingDate?.adults} adult{BooingDate?.adults > 1 ? "s" : ""}
    {BooingDate?.children > 0 ? ` and ${BooingDate?.children} child${BooingDate?.children > 1 ? "ren" : ""}` : ""}
  </strong>
</p> */}
      {/* Address */}
      <p className="address">
              <FaMapMarkerAlt className="detail-icon" />
  {property.property?.address} 
  <a href="#">Show directions</a>
      </p>

      {/* Upgrade offer */}
      
    </div>




     


 <div className="safety-box">
        <h5>Special Requests
</h5>
        <p>
          Approximate time of arrival: between  {property.property?.checkIn.from}  and {property.property?.checkIn.until}. {" "}
If guest is interested in your airport shuttle service and would like to get more information from you.
        </p>
      </div>







      {/* Contact Property */}
      <div className="contact-property" style={{border: "1px solid #c3c3c3",padding :"10px " ,borderRadius:"10px"}}>
        <h4>Contact property</h4>
        <p>Got a question or need to arrange something for your stay?</p>
          
                <div style={{display:"flex",alignItems: "center"}}>

          <FaEnvelope style={{ color:"grey",fontSize:"19px",marginRight:"15px"}} /> 
          <div className="contact-option">
        <b>Email property</b>
          <p>Send a message to the property – they’ll respond as soon as possible</p>
          <a href="mailto:info@yovho.com">Send an email</a>
        </div>
        </div>

      <div style={{display:"flex",alignItems: "center"}}>
        <FaPhoneAlt style={{ color:"grey",fontSize:"19px",marginRight:"15px"}} /> 
       <div className="contact-option">
           <b>Other options</b>
          <p><a href="tel:+923310222068">Call +92 331 0222068</a></p>
        </div>
      </div>
      
      </div>


      {/* Contact Property */}
      <div className="contact-property" style={{borderTop: "1px solid #c3c3c3",padding :"10px " ,borderRadius:"10px"}}>
        <h4>Need help?</h4>
        {/* <p>We're here to help answer your questions and manage your booking
</p> */}
          
                <div style={{display:"flex",alignItems: "center"}}>

          <FaEnvelope style={{ color:"grey",fontSize:"19px",marginRight:"15px"}} /> 
          <div className="contact-option">
        {/* <b>Email property</b> */}
          <p>We're here to help answer your questions and manage your booking</p>
          <a href="mailto:info@yovho.com">Contact Customer Service</a>
        </div>
        </div>

      </div>

    </div>



<br />




          </div>
          <div className="col-lg-4">








 <div className="booking-actions-card">

      {/* Confirmation Number */}
      <div className="confirmation-box">
        <p>
          <b>Confirmation number:</b> <span className="highlight" style={{color:"blue"}}> <span onClick={handleCopy} style={{ cursor: "pointer" }} title="Copy">
      {bookingId} <FaRegCopy />
    </span></span>
        </p>
        {/* <p>
          <b>PIN:</b> <span className="highlight">0358</span>
        </p> */}
      </div>

      {/* Actions */}
      <div className="actions-box">
        <h4>Is everything correct?</h4>
        <p className="info-text">
          You can always view or change your booking online – no registration required.
        </p>
        <ul className="action-links">
 
<li>
  <FaTimesCircle className="icon" />{" "}
  <a href="#" onClick={(e) => { e.preventDefault(); openCancelModal(); }}>
    Cancel your booking
  </a>
</li>
{/* <li>
  <FaArrowUp className="icon" /> 
  <a href="#" onClick={(e) => { e.preventDefault(); handleUpgradeRoom(); }}>
    Upgrade your room
  </a>
</li> */}

          {/* <li ><FaTimesCircle className="icon" /> <a href="#" >Cancel your booking</a></li> */}
          <li><FaArrowUp className="icon" /> <a href="#">Upgrade your room</a></li>
          <li><FaCalendarAlt className="icon" /> <a href="#">Change dates</a></li>
          <li><FaExchangeAlt className="icon" /> <a href="#">Change your room</a></li>
          {/* <li><FaQuestionCircle className="icon" /> <a href="#">Found this stay cheaper elsewhere?</a></li> */}
        </ul>
      </div>

      {/* Contact Property */}
      <div className="contact-box">
        {/* <h4>Contact property</h4> */}
        {/* <p><FaPhoneAlt className="icon" />  <a href="+92 331 0222068">+92 331 0222068</a> </p> */}
        {/* <a href="#">Send a message</a><br /> */}
        {/* <a href="mailto:info@property.com">Send an email</a> */}
        <p className="tip">Tip: You can make changes to this booking anytime.</p>
      </div>

    </div>





<Modal show={showCancelModal} onHide={closeCancelModal}>
  <Modal.Header closeButton>
    <Modal.Title>Cancel Booking</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    Are you sure you want to cancel your booking?
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={closeCancelModal} disabled={cancelling}>
      Close
    </Button>
    <Button variant="danger" onClick={handleCancelBooking} disabled={cancelling}>
      {cancelling ? "Cancelling..." : "Cancel Booking"}
    </Button>
  </Modal.Footer>
</Modal>







  <div className="Room_booking-summary">

    {/* Hotel Info */}
        <div className="Room_hotel-card">
        <img
            src={property.property?.images[0]}
            alt="Hotel"
            className="Room_hotel-img"
        />
        <div className="Room_hotel-info">
            <span>{"★".repeat(property.property?.stars || 4)}</span>
            <h5>{property.property?.propertyName}</h5>
            <p className="Room_hotel-location">{property.property?.address}</p>
            <span className="Room_hotel-rating"> <span>4.6</span>  Pleasant · 606 reviews</span>
        </div>
        </div>
      <hr/>
        {/* Booking Details */}
        <div className="Room_card-box">
        <h6>Your booking details</h6>
        <div className="d-flex justify-content-between">
            <div style={{borderRight:"1px solid grey",width:"50%"}}>
            <p className="Room_title">Check-in</p>
            <p className="Room_para">{BooingDate ? new Date(BooingDate.checkIn).toLocaleDateString("en-US", { weekday: "short" }) : ""}, {property.bookingDate?.startDate}
              {/* Mon, Sep 22, 2025 */}
              </p>
            {/* <p className="Room_para1">{property.property?.checkIn.from}12:30 PM – {property.property?.checkIn.until}2:00 PM</p> */}
            </div>
            <div style={{paddingLeft:"15px"}}>
            <p className="Room_title">Check-out</p>
            <p className="Room_para">{BooingDate? new Date(BooingDate.checkOut).toLocaleDateString("en-US", { weekday: "short" }) : ""}, {property.bookingDate?.endDate}
              {/* Mon, Sep 22, 2025 */}
              </p>
            {/* <p className="Room_para1">{property.property?.checkOut.from} 12:00 PM – {property.property?.checkOut.until}1:30 PM</p> */}
            </div>
        </div>
        <hr />
        <h6>You selected</h6>


{/* <p><strong>1 night, 1 room for 2 adults</strong></p> */}
        <p>
  <strong>
    {Math.ceil(
      (new Date(BooingDate?.checkOut) - new Date(BooingDate?.checkIn)) / (1000 * 60 * 60 * 24)
    )}{" "}
    night{Math.ceil((new Date(BooingDate?.checkOut) - new Date(BooingDate?.checkIn)) / (1000 * 60 * 60 * 24)) > 1 ? "s" : ""},{" "}
    {property?.noOfRooms} room{property?.noOfRooms > 1 ? "s" : ""}  for {BooingDate?.adults} adult{BooingDate?.adults > 1 ? "s" : ""}
    {BooingDate?.children > 0 ? ` and ${BooingDate?.children} child${BooingDate?.children > 1 ? "ren" : ""}` : ""}
  </strong>
</p>

        <p>{property?.stayDurationInDays} night{property?.noOfRooms > 1 ? "s" : ""} × {property.Room?.roomDetails.customName}</p>
        {/* <a style={{color : "blue"}} href="/searchresults">Change your selection</a> */}
        </div>

        {/* Price Summary */}
        <div className="Room_card-box price-box">
        <h6>Your price summary</h6>
        <div className="Room_price-main" style={{fontSize:"22px"}}>
            <span className="Room_price-label"> <b>Price</b> </span>
            <span className="Room_price-amount"> <b style={{marginLeft:"5px"}}>PKR {property?.totalPrice}</b> </span>
        </div>
        <p className="Room_tax-note">+PKR {property?.taxs} taxes and fees<br/>
        {/* In property currency: US$135 */}
        </p>
        </div>

        {/* Price Info */}
        <div className="Room_card-box">
        <h6>Price information</h6>
        <ul className="Room_price-info">
            <li>Excludes PKR {property?.taxs} in taxes and fees</li>
            <li>15% Tax — PKR {property?.taxs}</li>
            {/* <li>This price is converted to show you the approximate cost in PKR. You’ll pay in USD. The exchange rate might change before you pay.</li> */}
            {/* <li>Keep in mind your card issuer may charge a foreign transaction fee.</li> */}
        </ul>
        </div>


        <div className="Room_card-box">
        <h6>Your payment schedule
</h6>
        <ul className="Room_price-info">
            <li style={{color :"#008009"}}>No payment today. You'll pay when you stay.
</li>
            {/* <li>15% Tax — PKR 5,697.85</li>
            <li>This price is converted to show you the approximate cost in PKR. You’ll pay in USD. The exchange rate might change before you pay.</li>
            <li>Keep in mind your card issuer may charge a foreign transaction fee.</li> */}
        </ul>
        </div>

    </div>














          </div>
        </div>
      </div>
    </div>



  );
};

export default ConfirmationBooking;
